export default __webpack_public_path__ + "static/media/blueCarbs.83b8f2a9.svg";